module.exports = __webpack_public_path__ + "img/36.49a0ebe.png";